import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'

import ecosystemWheel from '@static/vectors/ecosystem/wheel.svg'
import './Ecosystem.css'

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="landing-section">
      <img src={ecosystemWheel} alt="" />
      <header>
        <h1>
          <span>
            <MarkdownMessage id="ecosystem.section-1.title" />
          </span>
        </h1>
      </header>
      <div className="ecosystem-grid">
        {[1, 2, 3, 4, 5, 6].map((n) => (
          <article
            key={n}
            id={`ecosystem-card-${n}`}
            className="ecosystem-card"
          >
            <span className={`icon icon-ecosystem-${n}`}></span>
            <h2>
              <FormattedMessage id={`ecosystem-card.text-${n}`} />
            </h2>
          </article>
        ))}
      </div>
    </section>
  )
}
